//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Post } from "@/models";
import PostItem from '@/components/post_item/PostItem'

export default {
  created () {
    this.getPosts()
  },
  props: {
    channelId: {
      type: String,
      default: undefined
    },
    userId: {
      type: String,
      default: undefined
    },
    isLock: {
      type: Boolean,
      default: true 
    }
  },

  data () {
    return {
      posts: null,
      page: 1,
      perPage: 5,
      loading: false
    }
  },

  scrollBottom () {
    // 当isLock为false时才能进行截下来的请求
    // 使用v-if时不需要    
    if (this.isLock === undefined || this.isLock === true) {
      return
    }
    this.getPosts()
  },

  methods: {
    getPosts () {
      if (this.loading) {
        return
      }
      this.loading = true

      Post.getUserLikedPosts({
        userId: this.userId,
        channelId: this.channelId,
        page: this.page,
        perPage: this.perPage
      }).then((result) => {
        if (Array.isArray(result)) {
          this.posts = this.page == 1 && result || this.posts.concat(result)
          // console.log(this.posts)
          this.page += 1
          this.loading = false
        } else {
          throw new TypeError('posts is not a array')
        }
      }).catch((err) => {
        this.loading = false
      })
    },
  },

  components: {
    PostItem
  }
}



// WEBPACK FOOTER //
// ./src/pages/user-msg/UserMsgLikePosts.vue